import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { ApiCall, Colors, GOOGLE_API_KEY } from "../../common/Const";
import TextBox from "../pages/TextBox";
import { images } from "../../common/Images";
import { width } from "@mui/system";
import store from "../../redux/Store";
import { Autocomplete, LoadScript } from "@react-google-maps/api";
import $ from "jquery";
import EncryptDecrypt from "../../common/Crypto";

function GuestLogin() {
  const [email, inputChange] = useState("");
  const [fName, setFname] = useState("");
  const [lName, setLname] = useState("");
  const [visible, setvisible] = useState(false);
  const [phone_no, setPhone_no] = useState("");
  const [address, setAddress] = useState("");
  const [addresserror, setAddresserror] = useState("");
  const [BtnLoad, setBtnLoad] = useState(false);
  const [emailError, setemailError] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [FnameError, setFnameError] = useState("");
  const [LnameError, setLnameError] = useState("");
  const libraries = ["places"];
  const [places, setPlaces] = useState([]);
  const [lat, setLat] = useState("");
  const [lng, setLng] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [postcode, setPostcode] = useState("");
  const [country, setCountry] = useState("");
  const [specify, setSpecify] = useState("home");
  const [checked, setchecked] = useState(false);
  const [loader, setloader] = useState(false);
  const navigate = useNavigate();
  const onLoad = (Autocomplete) => {
    console.log(Autocomplete);
    setPlaces(Autocomplete);
  };
  const onPlaceChanged = () => {
    if (places !== null) {
      setLat(places.getPlace().geometry.location.lat());
      setLng(places.getPlace().geometry.location.lng());
      console.log(places.getPlace());
      setAddress(places.getPlace().name);
      var getplace = places.getPlace().address_components;
      console.log("slfsldfks;ldfksd;lfs", getplace.length);
      for (var i = 0; i < getplace.length; i++) {
        console.log(getplace[i], "address_comp[i]");

        if (getplace[i].types[0] == "sublocality_level_1") {
          setAddress1(getplace[i].long_name);
        } else if (getplace[i].types[0] == "locality") {
          setCity(getplace[i].long_name);
        } else if (getplace[i].types[0] == "administrative_area_level_1") {
          setState(getplace[i].long_name);
        } else if (getplace[i].types[0] == "country") {
          setCountry(getplace[i].long_name);
        } else if (getplace[i].types[0] == "postal_code") {
          setPostcode(getplace[i].long_name);
        } else if (getplace[i].types[0] == "route") {
          setAddress2(getplace[i]);
        }
      }
    } else {
      console.log("Autocomplete is not loaded yet");
    }
  };
  const prefixImg = (src) => {
    return (
      <div
        className="pre-icon"
        style={{ borderRight: `2px solid ${Colors.Base_color}` }}
      >
        {/* <i class="fa-solid fa-envelope"></i> */}
        <img
          src={src}
          className=""
          style={{ objectFit: "contain" }}
          height={25}
          width={25}
        />
      </div>
    );
  };
  const SuffixImg = (value, type = 1) => {
    if (type === 1) {
      return (
        <div
          role="button"
          className="sufficIm"
          onClick={() => setvisible(!visible)}
        >
          <i
            class={visible ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}
          ></i>
          {/* <img src={value} className='sufficImg' height={18} width={25} /> */}
        </div>
      );
    } else {
      return (
        <div
          role="button"
          className="sufficIm Pointer_eye"
          onClick={() => setvisible(!visible)}
        >
          <i style={{ color: "red" }} class="fa-regular fa-eye"></i>
        </div>
      );
    }
  };
  const loginFun = async (e) => {
    e.preventDefault();
    if (loginValidation()) {
      setPhoneError("");
      setemailError("");
      setBtnLoad(true);
      const guestRegister = {
        email: email,
        phone_number: phone_no,
        first_name: fName,
        last_name: lName,
        address: address,
        city: city,
        state: state,
        postal_code: postcode,
        latitude: lat,
        longitude: lng,
      };

      ApiCall("guestRegister", guestRegister)
        .then((data) => {
          if (data.message == "success") {
            let loginData = {
              id: data.result.id,
              first_name: data.result.first_name,
              last_name: data.result.last_name,
              email: data.result.email,
              phone_number: data.result.phone_number,
              avatar: data.result.avatar,
              userType: 1, // Normal user = 0, Guest user = 1
            };
            store.dispatch({ type: "addData", payload: loginData });
            localStorage.setItem("first_name", data.result.first_name);
            toast.success(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            setBtnLoad(false);
            $("#close_btn1").click();
            console.log("string -->",data.result.id);
              // setTimeout(async function () {
              //   let cus_id = data.result.id;
              //   let type = "encrypt";
              //   let format = "text";

              //   await EncryptDecrypt(cus_id, type, format, (callback) => {
              //     localStorage.setItem("customerId", callback);
              //   });

              //   await EncryptDecrypt(
              //     data.result.access_token,
              //     type,
              //     format,
              //     (callback) => {
              //       localStorage.setItem("access_token", callback);
              //     }
              //   );
              // }, 3000);
              setTimeout(() => {
                navigate("/mycart");
              }, 2000);
          } else {
            setBtnLoad(false);
            // console.log("data", data);
            toast.error(data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
          }
        })
        .catch((err) => console.log(err));
      // setBtnLoad(false);
      // setloader(true);
    }
    // }
  };
  const loginValidation = () => {
    let isValid = true;
    if (email == "") {
      isValid = false;
      setemailError("Enter your email");
    } else {
      setemailError("");
    }
    if (email !== "") {
      let lastAtPos = email.lastIndexOf("@");
      let lastDotPos = email.lastIndexOf(".");
      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf("@@") == -1 &&
          lastDotPos > 2
        )
      ) {
        isValid = false;
        setemailError("Enter valid Email");
      }
    }
    if (phone_no === "") {
      isValid = false;
      setPhoneError("Phone Number is required");
    } else {
      setPhoneError("");
    }

    if (
      (phone_no && phone_no.length > 10) ||
      (phone_no && phone_no.length < 10)
    ) {
      isValid = false;
      setPhoneError("Enter valid Phone number");
    }

    if (fName === "") {
      isValid = false;
      setFnameError("First Name Required");
    } else {
      setFnameError("");
    }
    if (lName === "") {
      isValid = false;
      setLnameError("Last Name Required");
    } else {
      setLnameError("");
    }
    if (address.trim() === "") {
      isValid = false;
      setAddresserror("Address Required");
    } else {
      if (lat === "" && lng === "") {
        isValid = false;
        setAddresserror("Enter valid address");
      } else {
        setAddresserror("");
      }
    }

    return isValid;
  };

  return (
    <div>
      <ToastContainer />
      <div
        class="modal fade"
        id="guestLogin"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div className="field-box mt-3 d-flex flex-column">
              <button
                type="button"
                class="btn-close cbutton"
                id="close_btn1"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{ position: "absolute", right: "10px" }}
              ></button>
              <div className="text-center">
                <p className="login-hd">Guest User</p>
                <span
                  className=""
                  style={{ color: "gray", fontFamily: "AvenirLTStdMedium" }}
                >
                  Enter Your email and Phone number!
                </span>
              </div>
              <TextBox
                type={"text"}
                prefix={prefixImg(images.user)}
                place={"First Name"}
                change={setFname}
                input_value={fName}
                name={"fName"}
              />
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {FnameError ? FnameError : " "}
              </span>
            </div>
            <div className="field-box mt-3 d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg(images.user)}
                place={"Last Name"}
                change={setLname}
                input_value={lName}
                name={"lName"}
              />
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {LnameError ? LnameError : " "}
              </span>
            </div>
            <div className="field-box mt-3 d-flex flex-column">
              <TextBox
                type={"text"}
                prefix={prefixImg(images.emailIcon)}
                place={"Email"}
                change={inputChange}
                input_value={email}
                name={"email"}
              />
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {emailError ? emailError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column">
              <TextBox
                type={"number"}
                prefix={prefixImg(images.phone_no)}
                place={"Phone Number"}
                change={setPhone_no}
                input_value={phone_no}
                name={"ph_number"}
              />
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {phoneError ? phoneError : " "}
              </span>
            </div>
            <div className="field-box d-flex flex-column" style={{ zIndex: 2 }}>
              <LoadScript
                googleMapsApiKey={GOOGLE_API_KEY}
                libraries={libraries}
              >
                <Autocomplete
                  className="w-100"
                  onLoad={onLoad}
                  onPlaceChanged={onPlaceChanged}
                  style={{ zIndex: 2 }}
                >
                  <TextBox
                    type={"text"}
                    prefix={prefixImg(images.locationImg)}
                    place={"Address"}
                    change={setAddress}
                    input_value={address}
                    name={"address"}
                  />
                </Autocomplete>
              </LoadScript>
              <span
                style={{
                  color: "red",
                  height: "5px",
                  alignSelf: "end",
                  marginTop: "-5px",
                }}
              >
                {addresserror ? addresserror : " "}
              </span>
            </div>
            <div
              style={{ width: "50%", marginLeft: "25%", marginBottom: "20px",marginTop: "40px" }}
            >
              <button
                className="btn btn-basic guestBtn"
                style={{ background: Colors.Base_color, color: "white" }}
                onClick={loginFun}
                disabled={BtnLoad ? true : false}
              >
                Ship to this Address
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default GuestLogin;
